export class PepParentesco {

    model = {
        id: { value: null, export: false },
        idp: { value: null, export: false },
        parentesco: {
            value: '',
            export: false,
            header: 'Parentesco',
            required: 'Información requerida',
            maxLength: 'Máximo 250 caracteres',
            minLength: 'Mínimo 3 caracteres',
            max: 250,
            min: 3,
            table: true,
            filter: false,
            sort: true
        },
        nombres: {
            value: '',
            export: false,
            table: true,
            header: 'Nombres y apellidos completos',
            required: 'Campo requerido',
            maxLength: 'Máximo 350 caracteres',
            minLength: 'Mínimo 3 caracteres',
            max: 350,
            min: 3
        },  
        razon_social: {
            value: '',
            table: true,
            header: 'Nombre / Razón Social',
        },
        nacionalidad: {
            value: null,
            table: true,
            header: 'Nacionalidad',
        },
        porcentaje: {
            value: 0,
            table: true,
            header: '% Participación',
        },      
    }
    optionLabel = 'nombre';
    msgFamiliar = <>Nombre de de sus familiares hasta el cuarto grado de consanguinidad y el segundo de afinidad:</>
    msgJuridico = <>Personas jurídicas donde mantenga una participación igual o superior al 10% en su capital, aporte o participación:</>
    strPep = <><p><b>PEP:</b> Son todas las personas naturales, nacionales o extranjeras, <b>que desempeñan o han desempeñado funciones</b> o cargos públicos destacados en el Ecuador o en el extranjero, 
                o funciones prominentes en una organización internacional, conforme a los lineamientos establecidos por la Unidad de Análisis Financiero y Económico (UAFE), y la Superintendencia 
                de Compañías, Valores y Seguros.<br />
                <b>Familiares y Personas Relacionadas de las Personas Expuestas Políticamente:</b> Se consideran como personas expuestas políticamente (PEP) a los familiares de las Personas Expuestas 
                Políticamente (PEP), sean estos los cónyuges o personas unidas bajo el régimen de unión de hecho, familiares hasta el segundo grado de consanguinidad o primero de afinidad; y el 
                o los colaborador (es) directo (s) esto es la (s) persona (s) natural (es) con las cuales una Persona Políticamente Expuesta (PEP), se encuentre asociada o vinculada 
                societariamente, o mantenga otro tipo de relaciones empresariales, comerciales o labores estrechas.</p><p>
                Los funcionarios públicos de menor grado que no estén comprendidos dentro del nivel jerárquico superior, se excluyen de la definición de PEP; con excepción de aquellos que ejerzan 
                la representación de un PEP o cumplan funciones en su nombre, para lo cual se realizará la correspondiente evaluación de riesgo.</p></>;
}
